<template>
    <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600px">
        <template v-slot:activator="{props}">
            <v-tooltip location="top">
                <template v-slot:activator="{props: tProps}">
                    <div v-bind="reason && isShowReason ? tProps : null">
                        <v-btn
                            :block="!mobile"
                            :class="{'my-2': !mobile}"
                            :small="small"
                            color="grey-lighten-1"
                            variant="flat"
                            size="large"
                            class="text-body-2 text-white"
                            v-bind="props"
                        >
                            {{ $t('unavailable') }}
                        </v-btn>
                    </div>
                </template>
                <span>{{ reason }}</span>
            </v-tooltip>
        </template>
        <v-card class="pt-5">
            <v-card-text>
                {{ $t('sold_out_modal_text') }}
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" variant="text" @click="dialog = !dialog">{{ $t('close') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class SoldOutModal extends Vue {
        @Prop({default: false, type: Boolean}) mobile
        @Prop({default: false, type: Boolean}) small
        @Prop() reason

        dialog = false

        get isShowReason() {
            return false
        }
    }

    export default SoldOutModal
</script>
